"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var clone = require('clone');

var tv4 = require('tv4');

var CardLabelValue = /*#__PURE__*/function () {
  function CardLabelValue(opt) {
    _classCallCheck(this, CardLabelValue);

    this.label = null;
    this.value = null;

    if (opt) {
      this.fillObject(clone(opt));
    }
  }

  _createClass(CardLabelValue, [{
    key: "fillObject",
    value: function fillObject(opt) {
      this.label = opt.label;
      this.value = opt.value || null;
    }
  }, {
    key: "validate",
    value: function validate() {
      return tv4.validateMultiple(this, CardLabelValue.schema());
    }
  }], [{
    key: "schema",
    value: function schema() {
      return {
        $schema: 'http://json-schema.org/draft-04/schema#',
        id: 'card-label-value.schema.json',
        type: 'object',
        additionalProperties: false,
        properties: {
          label: {
            type: 'string'
          },
          value: {
            type: ['string', 'null']
          }
        },
        required: Object.keys(this)
      };
    }
  }]);

  return CardLabelValue;
}();

module.exports = CardLabelValue;